window.addEventListener('load', () => {
    let tabs = document.querySelectorAll('.productView-info-tabs .tab');
    let tabContents = document.querySelectorAll('.productView-info-tabs .tab-content');
    let closeButton = document.querySelectorAll('.productView-info-tabs .close-button');
    let conditionCardButton = document.querySelectorAll('.condition-card');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            openTab(tab);
        })
    })

    closeButton.forEach(button => {
        button.addEventListener('click', () => {
            let content = button.closest('.tab-content');
            content.classList.remove('show');
            content.classList.remove('mobile-modal-active')
        })
    })

    conditionCardButton.forEach(button => {
        button.addEventListener('click', () => {
            tabs.forEach(tab => {
                if (tab.dataset.id === 'product_info_condition') {
                    openTab(tab);
                }
            })

            document.querySelector('[data-id="product_info_condition"].tab-content').scrollIntoView({ behavior: 'smooth' });
        })
    })

    function openTab(tab) {
        tabs.forEach(tab => {
            tab.classList.remove('active');
        })

        tab.classList.add('active');

        tabContents.forEach(content => {
            if (tab.dataset.id === content.dataset.id) {
                content.classList.add('active')
                content.classList.add('show')
                content.classList.add('mobile-modal-active')
            } else {
                content.classList.remove('active')
                content.classList.remove('mobile-modal-active')
                content.classList.remove('show')
            }
        });
    }
})